<div class="background-page">
    <router-outlet></router-outlet>
</div>